import React, { useEffect, useState } from 'react';
import Navbar from './Navbar/Navbar';
import Sidebar from './Sidebar/Sidebar';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { fetchUserAction } from '../../utils/redux/auth/authActions';
import { setAuthorizationToken } from '../../utils/api-service/api-service';
import './Layout.css';

const Layout = ({ children }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const returnJWT = async () => {
        let token = await Cookies.get('jwt');
        console.log("Token from cookies: ", token);
        return token || null;
    }

    const auth = async () => {
        const isAuthenticated = await returnJWT();
        if (isAuthenticated) {
            setAuthorizationToken(isAuthenticated);
            await dispatch(fetchUserAction());
        } else {
            setAuthorizationToken(null);
            navigate('/login')
        }
        setLoading(false)
    }

    useEffect(() => {
        auth();
    });

    if (loading) return <>LOADING...</>;


    return (
        <div className="layout-container">
            <Navbar />
            <div className="main-content">
                <Sidebar />
                <div className="page-content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;